import api from '@/services/api/api'

class DimensionsService {
  getAllDimensions () {
    return api.get('dimension').then(result => {
      return result.data
    })
  }
}

export default new DimensionsService()



// WEBPACK FOOTER //
// ./src/services/codebooks/DimensionsService.js